"use client"

import React from "react"
import {RadioGroup} from "@/components/ui/radio-group"
import {SingleProductEnum} from "@/constants/commerce-enum"
import {CommentRate} from "./comment-rates-data"

interface CommentRatesProps {
    selectedOption: CommentRate
    setSelectedOption: (option: CommentRate) => void
    commentRates: CommentRate[]
}

export function CommentRates({selectedOption, setSelectedOption, commentRates}: CommentRatesProps) {
    return (
        <div className="w-full flex flex-wrap border-b pb-5">
            <div className="w-full text-black text-sm font-medium text-start pb-2">
                {SingleProductEnum.rating}
            </div>
            <div className="w-full flex flex-wrap">
                <RadioGroup
                    dir={"rtl"}
                    onValueChange={(value) => {
                        const selected = commentRates.find((rate) => rate.value.toString() === value)
                        if (selected) {
                            setSelectedOption(selected)
                        }
                    }}
                    defaultValue={selectedOption.value.toString()}
                    className="flex md:gap-4"
                >
                    {commentRates.map((rate) => (
                        <div
                            key={rate.id}
                            className={`flex flex-col items-center justify-center transition-all duration-300 gap-2 w-[100px] h-[100px] border border-blue-secondary rounded-xl mt-4 cursor-pointer ${
                                selectedOption.id === rate.id
                                    ? "!border-orange-primary !text-orange-primary"
                                    : "!blue-secondary !text-blue-secondary"
                            }`}
                            onClick={() => setSelectedOption(rate)}
                        >
                            {rate.icon}
                            <p className="text-xs font-medium">{rate.title}</p>
                        </div>
                    ))}
                </RadioGroup>
            </div>
        </div>
    )
}